import { useMsal } from "@azure/msal-react";
import { useMemo } from "react";
import { useQueries } from "react-query";
import { getUser, IUser } from "services/security";
import { IUseUserQueriesProps } from "./interfaces";
import { IResponse } from "lib/common/interfaces";

export function useUserQueries({ ids }: IUseUserQueriesProps) {
  const { instance } = useMsal();

  const queries = useMemo(() => (
    ids.map((userId) => ({
      queryKey: ["user", userId],
      queryFn: async () => getUser(instance, { userId }),
      select: (response: IResponse<IUser> | undefined) => response?.data,
      enabled: !!userId
    }))
  ), [ids, instance]);

  return useQueries(queries);
}
